var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LvTwistCircle',{attrs:{"icon":"icon-risk-high-filled","color":"red","title":"高風險"}})
}
var staticRenderFns = []

export { render, staticRenderFns }